import { setBuilderToolbar } from '../../../../../Template/config/components/selection/SetBuilder';

export default {
  ...setBuilderToolbar,
  enableExcludeNonNormFilters: {
    ad: true,
    norm: true
  },
  exportButtons: {
    ad: {
      data: true,
      media: true
    },
    norm: {
      data: true,
      media: true
    }
  },
  sortOptions: [
    {
      "value": -1,
      "label": "Alpha Order by Brand",
      "field": "brand",
      "selected": false
    },
    {
      "value": 100,
      "label": "Ad Effect Score",
      "selected": true,
      "dataFormat": ".,0"
    },
    {
      "value": 110,
      "label": "Lift to Consideration",
      "selected": false
    },
    {
      "value": 101,
      "label": "Lift to Impression",
      "selected": false
    },
    {
      "value": 102,
      "label": "Net Actions",
      "selected": false,
    },
    {
      "value": 117,
      "label": "Likeability",
      "selected": false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/configuration/Max/config/components/selection/SetBuilder/setBuilderToolbar.js